import React from 'react'
import PropTypes from 'prop-types'
import 'static/css/ClickToPayToolTip.css'

const tooltipMessage = `O Click to Pay usará seu número de celular e e-mail para verificar se você vinculou cartões.

Um código de acesso poderá ser enviado para seu e-mail ou celular para confirmar sua identidade. Tarifas de dados/mensagens podem ser aplicadas.`

const ClickToPayToolTip = ({ show, onClose }) => {
  const handleBackdropClick = e => {
    e.stopPropagation()
    onClose()
  }

  if (!show) return null

  return (
    <>
      <span
        className="click-to-pay-info__backdrop"
        onClick={handleBackdropClick}
      />
      <span
        className="click-to-pay-info__tooltip"
        onClick={e => e.stopPropagation()}
      >
        {tooltipMessage}
      </span>
    </>
  )
}

ClickToPayToolTip.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ClickToPayToolTip
